module.exports = __webpack_public_path__ + "static/media/6_avatar.3dd2d434.png";